import "./About_Banner.css";
import { Banners } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const About_banner = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [banner, setBanner] = useState({});

  console.log("About banner", banner);

  const getBanner = async () => {
    const res = await Banners();

    if (res?.success) {
      setBanner(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="about_banner container">
      <div className="banner_wrapper">
        <img
          src={IDS?.IMG_URL + banner?.image}
          style={{ height: "500px", width: "1550px" }}
          alt="About_Banner"
          className="img_wrapper"
        />
        <div className="banner_content">
          <h1>{banner?.name}</h1>
        </div>
      </div>
      <div className=" text_holder">
        <p className="card_text">
          {htmlToReactParser.parse(banner?.description)}
        </p>

        <p className="card_text"> </p>

        <p className="card_text"> </p>
      </div>
    </section>
  );
};

export default About_banner;
